import React from 'react'

const WeekendOffer = () => {
  return (
    <div>
        <img src="/images/weekend.webp" alt="" />
    </div>
  )
}

export default WeekendOffer